

define(['angular', 'squid/index', 'components/xo-beaver/dist/logger', './fallback'], function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.lib.contingency', ['squid', 'beaver', 'hermes.lib.fallback']).factory('$contingencyHandler', function ($Contingency, $logger, $location, $state, $locale, $FallbackError, $Forbidden) {

        function showGenericError(code) {
            return function (errCode) {
                errCode = code ? code : errCode;
                // Encode error text
                errCode = errCode ? window.btoa(errCode) : errCode;
                $state.go('checkout.genericError', {
                    code: errCode
                });
            };
        }

        /**
         * Route with default parameters unless special handler implemented otherwise
         *
         * To satisfy url: '/pageAddCard/:country/:fiType' in the route definition.
         * {country: ..., fiType: ...} must be passed for ui.router..
         *
         */
        function route(path, params) {
            return function () {
                $state.go(path, params);
            };
        }

        var routeToAddCC = function routeToAddCC(msg, contingency) {
            var gamblingCauses = ['PAYER_FUNDING_INSTRUMENT_INELIGIBLE', 'PAYER_FINANCIAL_INSTRUMENT_OUT_OF_COUNTRY', 'PAYER_FINANCIAL_INSTRUMENT_UNDER_AGE'];
            var isGambling = gamblingCauses.indexOf(contingency.cause) > -1;
            var param = isGambling ? {
                gaming: '1'
            } : {};

            return route('checkout.pageAddCard.addCardFlow.addCard', param);
        };

        function forbidden(err) {
            throw new $Forbidden(err);
        }

        function fallback(product) {
            return function (err) {
                throw new $FallbackError({
                    reason: err,
                    product: product
                });
            };
        }

        return function (contingency) {
            if (contingency instanceof $Contingency) {

                // Leave a footprint here. The subsequent state where log how it goes..
                $logger.warn('contingency_handler', contingency);

                return contingency.handle({
                    // TODO : modify these routes
                    // Route
                    NEED_CREDIT_CARD: routeToAddCC,
                    NEED_CONFIRMED_CARD: routeToAddCC,
                    NEED_CREDIT_CARD_OR_BANK_ACCOUNT: routeToAddCC,
                    EXPIRED_CREDIT_CARD: routeToAddCC,

                    // Generic Error Pages
                    CURRENCY_COMPLIANCE: showGenericError(),
                    INVALID_RESOURCE_ID: showGenericError(),
                    PAYMENT_ALREADY_DONE: showGenericError(),
                    PAYEE_BLOCKED_TRANSACTION: showGenericError(),
                    RESTRICTED_USER: showGenericError(),
                    PAYMENT_DENIED: showGenericError(),
                    PAYER_CANNOT_PAY: showGenericError(),
                    PAYEE_ACCOUNT_RESTRICTED: showGenericError(),
                    PAYER_COUNTRY_NOT_ALLOWED: showGenericError(),
                    PAYER_COUNTRY_NOT_ALLOWED_DCF: showGenericError('XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF'),
                    PAYER_COUNTRY_NOT_ENABLED: showGenericError(),
                    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError(),
                    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError(),

                    // Fallbacks
                    TRANSACTION_REFUSED: fallback('ux'),
                    VERIFY_USER_IDENTITY: fallback('ux'),
                    SENDING_LIMIT_EXCEEDED: fallback('ux'),
                    PAYER_INVALID_FOR_PAYMENT: fallback('ux'),
                    PAYMENT_CANNOT_BE_INITIATED: fallback('ux'),
                    PERMISSION_DENIED: fallback('ux'),
                    NEGATIVE_BALANCE_TRANSACTION_REFUSED: fallback('ux'),
                    INVALID_TOKEN: fallback('ux'),
                    INVALID_FUNDING_OPTION: fallback('ux'),
                    INTERNAL_SERVICE_ERROR: fallback('ux'),
                    VALIDATION_ERROR: fallback('ux'),
                    SHIPPING_ADDRESS_INVALID: fallback('ux'),
                    RISK_DENIED: fallback('ux'),
                    DOMESTIC_TRANSACTION_REQUIRED: fallback('ux'),
                    INVALID_ARGUMENT: fallback('ux'),
                    CREDIT_PAYMENT_NOT_ALLOWED: fallback('ux'),
                    UNSUPPORTED_PAYEE_CURRENCY: fallback('ux'),
                    PAYEE_ACCOUNT_LOCKED_OR_CLOSED: fallback('ux'),
                    CANNOT_PAY_SELF: fallback('hermes'),

                    // Forbidden
                    BUYER_NOT_SET: forbidden,

                    // TODO: duplicate - PAYER_INVALID_FOR_PAYMENT: forbidden,
                    // Default
                    DEFAULT: function logUnhandledContingency() {
                        $logger.warn('ui_unhandled_contingency_' + this.message);

                        throw new $FallbackError({
                            reason: 'unhandled_contingency',
                            product: 'ux'
                        });
                    }
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./js/lib/contingency.js
// module id = ./js/lib/contingency.js
// module chunks = 1